import { render } from "./phone-bar.vue?vue&type=template&id=b1e03816&scoped=true"
import script from "./phone-bar.vue?vue&type=script&lang=js"
export * from "./phone-bar.vue?vue&type=script&lang=js"

import "./phone-bar.vue?vue&type=style&index=0&id=b1e03816&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-zju\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1e03816"]])

export default __exports__